import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { Template, UIFrame, Navigation, Lightbox, Iframe } from '..';

const Scenario = ({
  currentScenario,
  currentStep,
  setStep,
  canAdvance,
  canRewind,
  triggerEnd,
  triggerRestart,
  steps,
  advance,
  rewind,
  currentStepIsLastStep,
  hasOneScenario,
  content
}) => {
  if (!currentStep) return null;

  const { end } = content;
  const { video, image, hotspots } = currentStep;

  return (
    <Template
      navigation={
        <Navigation
          end={end}
          currentStep={currentStep}
          currentStepIsLastStep={currentStepIsLastStep}
          steps={steps}
          setStep={setStep}
          currentScenario={currentScenario}
          triggerRestart={triggerRestart}
          triggerEnd={triggerEnd}
          canAdvance={canAdvance}
          canRewind={canRewind}
          advance={advance}
          rewind={rewind}
          hasOneScenario={hasOneScenario}
        />
      }>
      {currentStep && (
        <UIFrame>
          {video && <Iframe src={video} />}
          {image && <img css={styles.screen} src={image} alt="" />}
          <Lightbox setStep={setStep} hotspots={hotspots} />
        </UIFrame>
      )}
    </Template>
  );
};

const styles = {
  screen: css`
    display: block;
    width: 100%;
    height: auto;
  `,
};

Scenario.propTypes = {
  content: PropTypes.object.isRequired,
  currentScenario: PropTypes.object.isRequired,
  currentStep: PropTypes.func.isRequired,
  currentStepIsLastStep: PropTypes.bool.isRequired,
  setStep: PropTypes.func.isRequired,
  canAdvance: PropTypes.bool.isRequired,
  canRewind: PropTypes.bool.isRequired,
  triggerEnd: PropTypes.func.isRequired,
  triggerRestart: PropTypes.func.isRequired,
  steps: PropTypes.array.isRequired,
  advance: PropTypes.func.isRequired,
  rewind: PropTypes.func.isRequired,
  hasOneScenario: PropTypes.bool.isRequired
};

export default Scenario;
